module.exports = __webpack_public_path__ + "img/totalInvoice.78434b76.svg";